import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Injectable({
  providedIn: 'root',
})
/**
 * Logout Guard blocks access if logout flow has not been initiated
 */
export class LogoutGuard implements CanActivate {
  /**
   * @constructor
   */
  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService
  ) {}

  /**
   * Activates only if log out flow has initiated
   * @return {boolean}
   */
  canActivate(): boolean {
    if (this.authenticationService.isLoggingOut) {
      return true;
    }
    this.router.navigate([RoutesKeys.HOME]);
    return false;
  }
}
